import { createContext, ReactNode, useContext } from "react"
import { DataSource } from "./source"

export const TableDataContext = createContext<unknown | undefined>(undefined)

export function useTableData<T>() {
  const ctx = useContext(TableDataContext)
  if (ctx === undefined) {
    throw new Error("useTableData :(")
  }
  return ctx as DataSource<T>
}

type TableDataProviderProps<T> = {
  children: ReactNode
  source: DataSource<T>
}

export function TableDataProvider<T>(props: TableDataProviderProps<T>) {
  return (
    <TableDataContext.Provider value={props.source}>
      {props.children}
    </TableDataContext.Provider>
  )
}
